<template>
  <div>
    <b-modal
      ref="keyboard-shortcut-modal"
      centered
      no-close-on-backdrop
      hide-footer
      title="Keyboard Shortcuts"
      size="md"
      @hide="hideShortcutModal"
      scrollable
    >
      <div class="key-shortcut">
        <b-row class="mt-1 mb-2">
          <b-col md="12">
            <p class="fw-normal m-0" style="font-size: 15px">Billing</p>
          </b-col>
        </b-row>
        <b-row class="pill-light align-items-center justify-content-between px-3 py-2">
          <p class="mb-0">Search the product(s)</p>
          <ul class="mb-0 list-inline">
            <li>Ctrl</li>
            <li>S</li>
          </ul>
        </b-row>
        <b-row class="align-items-center justify-content-between px-3 py-2">
          <p class="mb-0">View/Hide the catalog</p>
          <ul class="mb-0 list-inline">
            <li>Ctrl</li>
            <li>G</li>
          </ul>
        </b-row>
        <b-row class="pill-light align-items-center justify-content-between px-3 py-2">
          <p class="mb-0">Refresh the catalog</p>
          <ul class="mb-0 list-inline">
            <li>Ctrl</li>
            <li>Alt</li>
            <li>R</li>
          </ul>
        </b-row>
        <b-row class="align-items-center justify-content-between px-3 py-2">
          <p class="mb-0">View salesperson(s)</p>
          <ul class="mb-0 list-inline">
            <li>Ctrl</li>
            <li>1</li>
          </ul>
        </b-row>
        <b-row class="pill-light align-items-center justify-content-between px-3 py-2">
          <p class="mb-0">View held bill(s)</p>
          <ul class="mb-0 list-inline">
            <li>Ctrl</li>
            <li>2</li>
          </ul>
        </b-row>
        <b-row class="align-items-center justify-content-between px-3 py-2">
          <p class="mb-0">Hold the current bill</p>
          <ul class="mb-0 list-inline">
            <li>Ctrl</li>
            <li>3</li>
          </ul>
        </b-row>
        <b-row class="pill-light align-items-center justify-content-between px-3 py-2">
          <p class="mb-0">Add manual discount</p>
          <ul class="mb-0 list-inline">
            <li>Ctrl</li>
            <li>5</li>
          </ul>
        </b-row>
        <b-row class="align-items-center justify-content-between px-3 py-2">
          <p class="mb-0">Add carry bag(s)</p>
          <ul class="mb-0 list-inline">
            <li>Ctrl</li>
            <li>6</li>
          </ul>
        </b-row>
        <b-row class="pill-light align-items-center justify-content-between px-3 py-2">
          <p class="mb-0">Tag a customer</p>
          <ul class="mb-0 list-inline">
            <li>Ctrl</li>
            <li>A</li>
          </ul>
        </b-row>
        <b-row class="align-items-center justify-content-between px-3 py-2">
          <p class="mb-0">Cancel current bill</p>
          <ul class="mb-0 list-inline">
            <li>Ctrl</li>
            <li>X</li>
          </ul>
        </b-row>
        <b-row class="pill-light align-items-center justify-content-between px-3 py-2">
          <p class="mb-0">Checkout bill</p>
          <ul class="mb-0 list-inline">
            <li>Ctrl</li>
            <li>B</li>
          </ul>
        </b-row>
        <!-- <b-row>
          <b-button @click="hideShortcutModal">Close</b-button>
        </b-row>-->
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "keyboard-shortcut-modal",
  props: {
    openShortcuts: {
      type: Boolean
    }
  },
  watch: {
    openShortcuts() {
      if (this.openShortcuts == true) {
        this.$refs["keyboard-shortcut-modal"].show();
      } else if (this.openShortcuts == false) {
        this.hideShortcutModal();
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    hideShortcutModal() {
      this.$refs["keyboard-shortcut-modal"].hide();
      this.$emit("hide");
    }
  }
};
</script>

<style lang="scss" scoped>
.key-shortcut {
  li {
    position: relative;
    padding: 2px 8px;
    font-size: 12px;
    border-radius: 5px;
    background: $light-grey;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    margin-right: 15px;
    border: 1px solid $dark-grey;
    box-shadow: 0 1px 0 $dark-grey;
    &:after {
      content: "+";
      position: absolute;
      right: -12px;
      padding-left: 5px;
    }
    &:last-child {
      margin-right: 0px;
      &:after {
        display: none;
      }
    }
  }
}
.theme-dark .key-shortcut {
  li {
    &:after {
      color: $light-grey;
    }
  }
}
</style>